import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';

const Pagination = ({ pagination, paginationSelect }) => {
  const [bulletList, setBulletList] = useState([]);

  useEffect(() => {
    let cnt = [];
    for (let i = 0; i < pagination.length; i++) {
      cnt.push(i);
    }

    setBulletList(cnt);
  }, [pagination, paginationSelect]);

  return (
    <>
      {bulletList?.length > 0 &&
        bulletList?.map((d, i) => {
          return <Bullet key={`Bullet_${i}`} select={d === paginationSelect} />;
        })}
    </>
  );
};

export default Pagination;

const Bullet = styled.div`
  width: 7px;
  height: 7px;
  background-color: ${props => props.theme.disabledText};
  border-radius: 50%;
  margin: 0 3px;

  ${props =>
    props.select &&
    css`
      background-color: ${props => props.theme.button};
    `}
`;
